<template>
  <div class="leaderboard-bg">
    <top-navigation>
      <template><h1 class="high-scores" slot="middle">HIGH SCORES</h1></template>
    </top-navigation>
    <div id="leaderboard" class="container-fluid leaderboard mt-5 h-75">
      <div class="row mb-1" :key="i" v-for="(user, i) in items">
        <div class="col-1 position">
          {{ i + 1 }}.
        </div>
        <div class="col-1 p-0">
          <div class="avatar">
            <img :src="user.avatar">
          </div>
        </div>
        <div class="col-4 p-0">
          <div class="username pl-5">
            {{ user.username }}
          </div>
        </div>
        <div class="col-3 p-0">
          <div class="score">
            {{ user.score }}
          </div>
        </div>
        <div class="col-3 p-0">
          <div class="shoe">
            <img :src="user.avatarShoe" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'
import TopNavigation from '../components/TopNavigation'
import { enableBodyScroll } from 'body-scroll-lock'

export default {
  name: 'LeaderBoard',
  components: { TopNavigation },
  data () {
    return {
      items: []
    }
  },
  mounted () {
    enableBodyScroll(document.getElementById('leaderboard'))
    api.getLeaderBoard().then(data => {
      this.items = data.sort((a, b) => {
        return a.score < b.score ? 1 : -1
      })
    })
  }
}
</script>

<style scoped>
  .leaderboard-bg {
    height: 100%;
    background-image: url("../assets/img/leaderboard-bg.jpg");
    background-size: cover;
    background-position: center;
  }

  h1 {
    color: #ffcc00;
    font-family: "Geograph-Black";
  }

  .row {
    color: #fff;
    font-family: "Geograph-Black";
    text-align: center;
  }

  .row > div > div {
    height: 12vh;
  }

  .shoe {
    overflow: hidden;
  }

  .shoe img {
    height: 100%;
    transform: scale(3);
  }

  .avatar {
    padding-top: 0.5vh;
    padding-bottom: 0.5vh;
  }
  .avatar img {
    height: 100%;
    position: relative;
    z-index: 99;
    left: 0;
  }

  .position, .score {
    font-size: 2.4vw;
  }

  .username {
    text-align: left;
    color: #feca33;
    font-size: 2vw;
  }

  .shop, .score, .position {
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }

  .row a {
    color: #ffffff;
    text-decoration: underline;
  }

   .username {
    background: linear-gradient(to right, rgba(0,0,0,0.5) 0%,rgba(0,0,0,0.8) 100%);
  }

  .avatar, .position {
    background: rgba(0, 0, 0, 0.5);
  }

  .shoe, .score {
    background: rgba(0,0,0,0.8)
  }

  .leaderboard {
    overflow: hidden;
    overflow-y: scroll;
    scrollbar-face-color: #646464;
    scrollbar-base-color: #646464;
    scrollbar-3dlight-color: #646464;
    scrollbar-highlight-color: #646464;
    scrollbar-track-color: #000;
    scrollbar-arrow-color: #000;
    scrollbar-shadow-color: #646464;
    scrollbar-dark-shadow-color: #646464;
  }

  ::-webkit-scrollbar { width: 8px; height: 3px;}
  ::-webkit-scrollbar-button {  background-color: #666; }
  ::-webkit-scrollbar-track {  background-color: #646464;}
  ::-webkit-scrollbar-track-piece { background-color: #000;}
  ::-webkit-scrollbar-thumb { height: 50px; background-color: #666; border-radius: 3px;}
  ::-webkit-scrollbar-corner { background-color: #646464;}
  ::-webkit-resizer { background-color: #666;}

  .high-scores {
    text-shadow: 0px 3px 2px rgba(0, 0, 0, 0.8);
    font-size: 6vh;
  }
</style>
